
//@path src/components/assets/AssetsFilters.js
import React, { useState } from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import { Form } from 'common/components';

const AssetsFilters = ({
  isCollapsed,
  accounts = [],
  costCenters = [],
  employees = [],
  locations = [],
  providers = [],
  projects = [],
  physicalState = [],
  status = [],
  handleSubmit = () => {},
  handleValueChange = () => {},
  handleToggleSearch = () => {}, // Agregar
  handleExactSearch = () => {}, // Agregar
  columnSearch = [],
  t,
  values = {},
}) => {
  const accountsOptions = accounts.map((a) => ({ label: `${a.key} - ${a.name}`, value: a.id }));
  const locationsOptions = locations.map((l) => ({ label: `${l.name}`, value: l.id }));
  const costCentersOptions = costCenters.map((c) => ({
    label: `${c.key} - ${c.name}`,
    value: c.id,
  }));
  const employeesOptions = employees.map((e) => ({ label: `${e.key} - ${e.name}`, value: e.id }));
  const providersOptions = providers.map((e) => ({ label: `${e.key} - ${e.name}`, value: e.id }));
  const projectsOptions = projects.map((p) => ({ label: `${p.key} - ${p.name}`, value: p.id }));
  const physicalStateOptions = (physicalState || []).filter((ps) => ps && ps.active && !ps.deleted).map((ps) => ({
    label: `${t(ps.value)}`,
    value: ps.id,
  }));

  const statusNotDeleted = []; // Error al traer un dato como undefined.
  status.forEach((s) => (s ? statusNotDeleted.push(s) : null));
  const statusOptions = statusNotDeleted.map((s) => ({ label: t(s.value), value: s.id }));
  return (
    <form onSubmit={handleSubmit} noValidate autoComplete="false">
      {/* TODO: Pasar el texto hardcoded a i18n */}

      <div className={classnames('collapse row mt-5', { show: isCollapsed })}>
        <div className="col-6 col-sm-6 col-md-4 col-lg-2">
          <Form.FieldInput
            autoFocus={true}
            name={'fulltext'}
            label={t('actions.search')}
            placeholder={t('actions.search')}
            handleChange={handleValueChange}
            t={t}
            value={values.fulltext}
          />
        </div>
        <div className="col-6 col-sm-6 col-md-4 col-lg-2 mt-1">
          {/* ColumnSearch */}
          <div className="dropdown pb-4">
            <button
              className="btn btn-secondary dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {t('actions.selectSearch')}
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <div className="dropdown-item form-check form-check-inline">
                {/* <hr class="solid"></hr> */}
                <label className="form-check-label">{t('actions.selectedSearch')}</label>
              </div>
              {columnSearch.map((column) => {
                return (
                  <div className="dropdown-item form-check form-check-inline">
                    <input
                      type="checkbox"
                      checked={column.search}
                      class="form-check-input"
                      onClick={(e) => {
                        handleToggleSearch(column.key);
                      }}
                    />
                    <label
                      className="form-check-label"
                      onClick={(e) => {
                        e && e.preventDefault();
                        handleToggleSearch(column.key);
                      }}
                    >
                      {column.name}
                    </label>
                  </div>
                );
              })}
              <hr class="solid"></hr>
              <div className="dropdown-item form-check form-check-inline">
                <label className="form-check-label">{t('actions.optionsSearch')}</label>
              </div>

              <div className="dropdown-item form-check form-check-inline">
                <input
                  type="checkbox"
                  checked={values.exactSearch}
                  class="form-check-input"
                  onClick={(e) => {
                    handleExactSearch();
                  }}
                />
                <label
                  className="form-check-label"
                  onClick={(e) => {
                    e && e.preventDefault();
                    handleExactSearch();
                  }}
                >
                  {t('actions.exactSearch')}
                </label>
              </div>
            </div>
          </div>
          {/* ColumnSearch */}
        </div>
        <div className="col-sm-6 col-md-4">
          <Form.FieldMultiSelect
            options={accountsOptions}
            autoFocus={true}
            label={t('reports.fields.accounts')}
            name={'accounts'}
            placeholder={t('reports.fields.accounts')}
            handleChange={handleValueChange}
            value={values.accounts}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <Form.FieldMultiSelect
            options={costCentersOptions}
            autoFocus={true}
            label={t('reports.fields.costCenters')}
            name={'costCenters'}
            placeholder={t('reports.fields.costCenters')}
            handleChange={handleValueChange}
            value={values.costCenters}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <Form.FieldMultiSelect
            options={employeesOptions}
            autoFocus={true}
            label={t('reports.fields.employees')}
            name={'employees'}
            placeholder={t('reports.fields.employees')}
            handleChange={handleValueChange}
            value={values.employees}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <Form.FieldMultiSelect
            options={providersOptions}
            autoFocus={true}
            label={t('reports.fields.providers')}
            name={'providers'}
            placeholder={t('reports.fields.providers')}
            handleChange={handleValueChange}
            value={values.providers}
          />
        </div>

        <div className="col-sm-6 col-md-4">
          <Form.FieldMultiSelect
            options={statusOptions}
            autoFocus={true}
            label={t('reports.fields.status')}
            name={'status'}
            placeholder={t('reports.fields.status')}
            handleChange={handleValueChange}
            value={values.status}
          />
        </div>
        <div className="col-sm-6 col-md-4 mt-4">
          <Form.FieldSelect
            autoFocus={true}
            label={t('reports.fields.disabled')}
            name={'areDisabled'}
            handleChange={handleValueChange}
            value={values.areDisabled}
          >
            <option value="no">{t('actions.noDischarged')}</option>
            <option value="yes">{t('actions.discharged')}</option>
            <option value="both">{t('actions.all')}</option>
          </Form.FieldSelect>
        </div>
        <div className="col-sm-6 col-md-4 mt-4">
          <Form.FieldSelect
            autoFocus={true}
            label={t('reports.fields.hasPendingChanges')}
            name={'hasPendingChanges'}
            handleChange={handleValueChange}
            value={values.hasPendingChanges}
          >
            <option value="no">{t('actions.noChangesToReview')}</option>
            <option value="yes">{t('actions.changesToReview')}</option>
            <option value="both">{t('actions.all')}</option>
          </Form.FieldSelect>
        </div>
        <div className="col-sm-6 col-md-4 mt-4">
          <Form.FieldMultiSelect
            options={locationsOptions}
            autoFocus={true}
            label={t('menu.locations')}
            name={'location'}
            placeholder={t('menu.locations')}
            handleChange={handleValueChange}
            value={values.location}
          />
        </div>
        <div className="col-sm-6 col-md-4 mb-3">
          <Form.FieldMultiSelect
            options={projectsOptions}
            autoFocus={true}
            label={t('reports.fields.projects')}
            name={'projects'}
            placeholder={t('reports.fields.projects')}
            handleChange={handleValueChange}
            value={values.projects}
          />
        </div>
        <div className="col-sm-6 col-md-4 mb-3">
          <Form.FieldMultiSelect
            options={physicalStateOptions}
            autoFocus={true}
            label={t('reports.fields.physicalState')}
            name={'_physicalState'}
            placeholder={t('reports.fields.physicalState')}
            handleChange={handleValueChange}
            value={values._physicalState}
          />
        </div>
      </div>
    </form>
  );
};

export default translate()(AssetsFilters);



// WEBPACK FOOTER //
// src/components/assets/AssetsFilters.js